import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RouteComponentProps } from "@reach/router";
import styled from 'styled-components';
import { selectAllPositions, toggleListExpanded } from '../../../store/positions/positionsSlice';
import { Position } from './Position';
import { isJsonEqual } from '../../../lib/typeCheck';

const StyledListContainer = styled.div`
  width: 100%;
  height: 100%;
  background: #FFF;
  overflow-y: scroll;
`;

const Content = styled.div`
  margin: 0px 10px 0px 10px;
`;

const TopBar = styled.div`
  width: 100%;
  height: 56px;
  // border-bottom: 1px solid #AAA;
`;

const Heading = styled.div`
  padding-top: 20px;
  width: 100%;
  font-size: 30px;
  text-align: center;
  color: #233567;
`;

const StyledList = styled.div`
  margin: 50px auto;
  width: 80%;  
`;

const Table = styled.table`
  width: 100%;
`;

const Thead = styled.thead``;

const Tbody = styled.tbody``;

const Row = styled.tr`
  colour: #292D34;
  font-size: 18px;
  padding 20px 0;
`;

const HeadingCell = styled.th`
  vertical-align: middle;
  height: 40px;
  font-size: 22x;
  padding: 10px;
`;

export const List = (props: RouteComponentProps) => {
  const positions = useSelector(selectAllPositions, isJsonEqual) || [];
  
  return (
    <StyledListContainer>
      <TopBar/>
      <Content>
        <Heading>Positions</Heading>
        <StyledList>
          <Table>
            <Thead>
              <Row>
                <HeadingCell></HeadingCell>
                <HeadingCell></HeadingCell>
                <HeadingCell>Position</HeadingCell>
                <HeadingCell>Site</HeadingCell>
                <HeadingCell>Type</HeadingCell>
                <HeadingCell>Exceedances</HeadingCell>
                <HeadingCell>Last Data</HeadingCell>
                <HeadingCell>Voltage</HeadingCell>
                <HeadingCell></HeadingCell>
              </Row>
            </Thead>
            <Tbody>
              {positions.map(position => (
                <Position key={position.station_id} position={position} toggleListExpanded={toggleListExpanded}/>
              ))}
            </Tbody>
          </Table>
        </StyledList>
      </Content>
    </StyledListContainer>
  )
}